<div class="light-blue d-flex align-items-center">
    <!-- <div class="light-blue py-4"></div> -->
  <div class="container my-5">
      <div class="row d-flex align-items-center">
          <div class="col-md-4 col-12 px-3">
              <div class="first-block text text-center text-md-left">
                  <h1>{{'Un campus virtuel pour les équipes à distance' | translate}}</h1>
                  <p>{{'Immersive Factory vous propose de sensibiliser vos équipes aux risques professionnels sur un campus virtuel 100% immersif.' | translate}}</p>
                  <div class="mb-3 mb-md-0">
                      <button class="btn btn-immersive btn-rounded free-access-btn" [routerLink]="language.navigateAccordingToLang(['/about-us/o'])" title="contact"><i class="fas fa-envelope mr-2"></i>{{'Contact us' | translate}}</button>
                  </div>
              </div>
          </div>
          <div class="col-md-8 col-12">
              <div class="first-block pic">
                  <picture>
                      <source srcset="assets/all-small-pic-png.webp" type="image/webp">
                      <source srcset="assets/all-small-pic.png" type="image/png">
                      <img src="assets/all-small-pic.png" alt="A virtual campus for remote teams" title="Virtual campus" loading="lazy">
                  </picture>
              </div>
          </div>
      </div>
  </div>
</div>
<hr class="mt-0 pt-0">


<div class="container my-5 py-2">
  <div class="row">
    <div class="col-12 col-md-6 pr-4 mb-4 mb-md-0" *ngFor="let card of priceCards">
      <tarifs-card [config]="card"></tarifs-card>
    </div>
    <div class="col-12 col-md-6 pl-4 text-center">
      <h1 class="title-subbar">{{"Essayez le campus dès maintenant" | translate}}</h1>
      <p class="my-4 text-justify-center">{{"Créez vous un compte gratuitement depuis la page de téléchargement d'Immersive Factory et téléchargez le campus virtuel sur votre ordinateur Windows ou MacOs" | translate}}</p>
      <div class="videoContainer radius-10 shadow">
        <video poster="https://immersivemisc.s3.eu-west-3.amazonaws.com/videos/posters/campus-download-tuto.jpg" autoplay="autoplay" muted="muted" webkit-playsinline="true" playsinline="true" loop="loop" preload="auto">
            <source src="https://immersivemisc.s3.eu-west-3.amazonaws.com/videos/campus-download-tuto.webm" type="video/webm">
            <source src="https://immersivemisc.s3.eu-west-3.amazonaws.com/videos/campus-download-tuto.mp4" type="video/mp4">
        </video>
      </div>
      <a class="mt-4 btn btn-blue btn-rounded py-3 px-4" *ngIf="accountService.isLogged()" [href]="language.getAccountink('campus')" title="campus"><i class="fas fa-sign-in-alt mr-2"></i>{{'Essayer gratuitement' | translate}}</a>
      <a class="mt-4 btn btn-blue btn-rounded py-3 px-4" *ngIf="!accountService.isLogged()" [routerLink]="language.navigateAccordingToLang(['/register'])" title="registration"><i class="fas fa-sign-in-alt mr-2"></i>{{'Essayer gratuitement' | translate}}</a>
    </div>
  </div>
</div>

<div class="mb-5 p-5 light-blue2 text-justify-center">
  <h4 class="font-weight-bold">{{'Envie d’en savoir plus ou de travailler avec nous ?' | translate}}</h4>
  <p class="font-weight-light">{{'Notre équipe se fera un plaisir de répondre à vos questions ou de discuter de vos besoins' | translate}}.<br>{{'Contactez-nous dès aujourd’hui et nous vous répondrons dans la journée !' | translate}}</p>
  <button class="btn btn-blue btn-rounded mt-2 py-3 px-4" [routerLink]="language.navigateAccordingToLang(['/about-us/o'])" [state]="{'prefillContact' : 'Virtual campus'}" title="contact"><i class="fas fa-envelope mr-2"></i>{{'Nous contacter' | translate}}</button>
</div>


<div class="container my-5 py-2">
    <!-- <div class="container py-4 my-5"></div> -->
    <div class="row mb-5">
      <div class="col-12 py-0 position-relative">
        <div class="p-5 banner-campus d-flex flex-column flex-lg-row justify-content-lg-end align-items-center radius-10">
          <div class="text-center">
            <h2 class="mb-4 title-banner">{{'Campus virtuel' | translate}}</h2>
            <a class="btn btn-blue btn-rounded py-3 px-4" *ngIf="accountService.isLogged()" [href]="language.getAccountink('campus')" title="campus"><i class="fas fa-sign-in-alt mr-2"></i>{{'Essayer gratuitement' | translate}}</a>
            <a class="btn btn-blue btn-rounded py-3 px-4" *ngIf="!accountService.isLogged()" [routerLink]="language.navigateAccordingToLang(['/register'])" title="registration"><i class="fas fa-sign-in-alt mr-2"></i>{{'Essayer gratuitement' | translate}}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
        <div class="col-md-6 col-12 text-center text-md-left mb-3 mb-md-0">
          <a href="https://youtu.be/wjR2dT_3HWs" rel="noopener nofollow" target="_blank" title="video trailer">
            <picture>
                <source srcset="assets/Mockup_New_EHS_Platform.webp" type="image/webp">
                <source srcset="assets/Mockup_New_EHS_Platform.png" type="image/png">
                <img src="assets/Mockup_New_EHS_Platform.png" class="mockup" alt="Video trailer New EHS virtual campus" title="EHS virtual campus" loading="lazy">
            </picture>
          </a>
        </div>
        <div class="col-md-6 col-12 text-center text-md-justify">
            <span class="title sub-bar">{{'Des évènements virtuels' | translate}}</span>
            <p class="pt-4">
                {{'Pour une approche différente de la prévention des risques dans votre entreprise, lors de votre' | translate}} <span class="text-immersive font-weight-bold">{{'Journée ou Semaine sécurité' | translate}}</span>,
                <span class="bold">Immersive Factory</span> {{'a développé une' | translate}}
                <span class="text-immersive font-weight-bold">{{'plateforme de formations et d’évènements immersifs' | translate}}</span>
                {{'clé en main. Permanente et accessible quel que soit le support (PC, avec ou sans casque VR, tablette), elle complète parfaitement le parcours d’apprentissage sans exiger le moindre rapprochement physique des participants.' | translate}}
            </p>
        </div>
    </div>
</div>
<div class="citation-block my-5 mb-5">
    <div class="py-5">
        <div class="text-center">
            <span class="title sub-bar">{{'Optez pour la formation immersive 3D' | translate}}</span>
        </div>
        <div class="container my-5">
            <p>{{ 'Vous voulez innover en proposant une journée sécurité au sein d’un campus virtuel ?' | translate}} <span class="bold">Immersive Factory</span> {{ 'a développé un outil clé en main permettant d’organiser,' | translate}} <span class="text-immersive font-weight-bold">{{ 'sur campus virtuel personnalisable' | translate}}</span>{{ ', un évènement permanent pour sensibiliser chaque jour aux risques et à la sécurité.' | translate}}</p>
            <div class="row all-cards">
                <div class="col-md-4 col-sm-6 mb-4">
                    <div class="block-safety block">
                        <div class="text-immersive">
                            <app-svg-icon [src]="'assets/svg/Idea.svg'" [size]="'45px'"></app-svg-icon>
                        </div>
                        <div class="mt-3">
                            <span class="text-immersive font-weight-bold">{{'Système innovant' | translate}}</span>
                            <p class="mt-3">{{'Une approche originale et ludique pour diffuser votre culture sécurité au sein de vos équipes, toutes générations confondues.' | translate}}</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-sm-6 mb-4">
                    <div class="block-safety block">
                        <div class="text-immersive">
                            <app-svg-icon [src]="'assets/svg/workshopss.svg'" [size]="'45px'"></app-svg-icon>
                        </div>
                        <div class="mt-3">
                            <span class="text-immersive font-weight-bold">{{'Campus virtuel' | translate}}</span>
                            <p class="mt-3">{{'Organisez et animez vos évènements HSE à distance afin d’éviter les regroupements de personnes sur un même site.' | translate}}</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-sm-6 mb-4">
                    <div class="block-safety block">
                        <div class="text-immersive">
                            <app-svg-icon [src]="'assets/svg/POC.svg'" [size]="'45px'"></app-svg-icon>
                        </div>
                        <div class="mt-3">
                            <span class="text-immersive font-weight-bold">{{'Accompagnement & expertise' | translate}}</span>
                            <p class="mt-3">{{'Vos employés bénéficieront du soutien et des conseils de nos experts tout au long des évènements.' | translate}}</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-sm-6 mb-4">
                    <div class="block-safety block">
                        <div class="text-immersive">
                            <app-svg-icon [src]="'assets/svg/360.svg'" [size]="'45px'"></app-svg-icon>
                        </div>
                        <div class="mt-3">
                            <span class="text-immersive font-weight-bold">{{'Immersion totale' | translate}}</span>
                            <p class="mt-3">{{'Plongez au sein d’un environnement virtuel réaliste inspiré de situations dangereuses réelles.' | translate}}</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-sm-6 mb-4">
                    <div class="block-safety block">
                        <div class="text-immersive">
                            <app-svg-icon [src]="'assets/svg/Gamepad.svg'" [size]="'45px'"></app-svg-icon>
                        </div>
                        <div class="mt-3">
                            <span class="text-immersive font-weight-bold">{{'Contenu riche & diversifié' | translate}}</span>
                            <p class="mt-3">{{'De nombreux exercices permettant à vos collaborateurs de prendre toute la mesure de leurs actions quotidiennes et des conséquences qui en résultent.' | translate}}</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-sm-6 mb-4">
                    <div class="block-safety block">
                        <div class="text-immersive">
                            <app-svg-icon [src]="'assets/svg/VR_Casque.svg'" [size]="'45px'"></app-svg-icon>
                        </div>
                        <div class="mt-3">
                            <span class="text-immersive font-weight-bold">{{'VR & PC' | translate}}</span>
                            <p class="mt-3">{{'Formation active, serious game ou encore escape games, notre catalogue d’activités est disponible en VR ou en simulation 3D sur PC.' | translate}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-center">
            <h4 class="bold">{{'Visitez notre site web pour découvrir toutes les possibilités qui s’offrent à vous :' | translate}}</h4>
            <button class="btn btn-immersive btn-rounded mt-1" [routerLink]="language.navigateAccordingToLang(['/'])" title="homepage">WWW.IMMERSIVEFACTORY.COM</button>
        </div>
    </div>
</div>
<div class="container">
    <div class="text-center mb-5">
        <span class="title sub-bar">{{'Les avantages d’un e-Safety Campus' | translate}}</span>
    </div>
    <div class="row">
        <div class="col-12 col-md-6 mb-5 d-flex justify-content-center align-items-center">
            <picture>
                <source srcset="assets/{{'Toutes_Images_Brain' | translate}}.webp" type="image/webp">
                <source srcset="assets/{{'Toutes_Images_Brain' | translate}}.png" type="image/png">
                <img src="assets/{{'Toutes_Images_Brain' | translate}}.png" class="img-avantage" alt="VR training workshops increase learner memory by 4" title="E-Safety Campus" loading="lazy">
            </picture>
        </div>
        <div class="col-12 col-md-6 mb-5 d-flex justify-content-center align-items-center">
            <div>
                <h4 class="bold"><i class="fas fa-check-circle mr-1 custom-circle"></i>{{'L’immersive Learning appliqué à l’HSE' | translate}}</h4>
                <p>
                    {{'La réalité virtuelle vous permet d’offrir à vos employés une immersion durant laquelle ils seront pleinement actifs, ce qui' | translate}}
                    <span class="text-immersive font-weight-bold">{{'multiplie par 4 la mémorisation' | translate}}</span> {{'de vos messages de sécurité par rapport à une formation transmissive classique*.' | translate}}
                </p>
                <h4 class="bold"><i class="fas fa-check-circle mr-1 custom-circle"></i>{{'Des scénarios d’un réalisme incroyable' | translate}}</h4>
                <p>
                    {{'Vos collaborateurs se retrouvent' | translate}}
                    <span class="text-immersive font-weight-bold">{{'dans le feu de l’action' | translate}}</span>
                    {{'et doivent faire preuve d’une grande concentration pour pouvoir réagir face aux évènements auxquels ils sont confrontés.' | translate}}
                </p>
                <h4 class="bold"><i class="fas fa-check-circle mr-1 custom-circle"></i>{{'Une sensibilisation pérenne & dynamique' | translate}}</h4>
                <p>
                    {{'Lors d’un' | translate}} <span class="text-immersive font-weight-bold">{{'évènement sécurité' | translate}}</span>
                    {{'(formation, meeting, conférence, ou exercices sur la plateforme d’Immersive Factory), les apprenants seront sensibilisés aux risques qui peuvent affecter leur sécurité (mauvaises postures, manutention, travail en hauteur, travail en espaces confinés, circulation véhicules/piétons, risques chimiques, etc.). Ainsi, quel que soit leur environnement de travail, ils seront à même d’' | translate}}
                    {{'adopter les bons gestes sur le long terme.' | translate}}
                </p>
            </div>
        </div>
    </div>
</div>
<div class="block-free-access py-5 mb-5">
    <div class="container px-5">
        <div class="block block-rounded">
            <div class="row">
                <div class="col-12 col-md-3 col-left">
                    <div>{{'Testez en ligne gratuitement :' | translate}}</div>
                    <button class="btn-immersive btn-immersive-rounded text-uppercase btn-rounded2" (click)="freeAccess()"><i class="fas fa-play mr-1"></i>{{'Free trial' | translate}}</button>
                </div>
                <div class="col-12 col-md-9 col-right">
                    <div class="citation">
                        <p class="bold citation-text">{{'Un apprentissage actif grâce auquel vos collaborateurs se souviennent de 90%* de ce qu’ils font' | translate}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container">
    <div class="text-center mb-5">
        <span class="title sub-bar">{{'Engagement et pédagogie active' | translate}}</span>
    </div>
    <div class="row">
        <div class="col-12 col-md-6 mb-5 d-flex justify-content-center align-items-center">
            <div>
                <h4 class="bold"><i class="fas fa-check-circle mr-1 custom-circle"></i>{{'Un apprentissage expérientiel' | translate}}</h4>
                <p>
                    {{'La' | translate}} <span class="text-immersive font-weight-bold">{{'pédagogie active' | translate}}</span> {{'se caractérise par des méthodes d’apprentissage qui favorisent' | translate}} <span class="text-immersive font-weight-bold">{{'l’implication' | translate}}</span>
                    {{'de l’apprenant dans sa formation. Grâce à cette approche qui repose sur' | translate}} <span class="text-immersive font-weight-bold">{{'l’engagement' | translate}}</span>{{', l’enseignement présente une dimension pratique qu’aucun cours magistral ne saurait proposer.' | translate}}
                </p>
                <h4 class="bold"><i class="fas fa-check-circle mr-1 custom-circle"></i>{{'Une aventure ludique illimitée' | translate}}</h4>
                <p>
                    {{'Accessible par abonnement mensuel, notre plateforme et ses nombreux exercices vous permettront d’organiser des' | translate}}<span class="text-immersive font-weight-bold"> {{'évènements permanents dédiés à la sécurité' | translate}}</span> {{'et entièrement' | translate}}
                    <span class="text-immersive font-weight-bold">{{'dématérialisés' | translate}}</span>{{'. Invitez vos collaborateurs à vivre une véritable expérience qu’ils pourront répéter autant de fois que souhaité.' | translate}}
                </p>
                <h4 class="bold"><i class="fas fa-check-circle mr-1 custom-circle"></i>{{'Interactions & Immersive Learning' | translate}}</h4>
                <p>
                    {{'Au lieu de recevoir passivement des informations, vos collaborateurs pourront' | translate}} <span class="text-immersive font-weight-bold">{{'interagir avec un environnement d’un réalisme confondant' | translate}}</span>
                    {{'à même de provoquer une authentique prise de conscience. Tout cela' | translate}} <span class="text-immersive font-weight-bold">{{'sans requérir la moindre proximité physique' | translate}}</span>{{', ni même des locaux dédiés.' | translate}}
                </p>
            </div>
        </div>
        <div class="col-12 col-md-6 mb-5 d-flex justify-content-center align-items-center">
            <picture>
                <source srcset="assets/{{'Toutes_Images_FR' | translate}}.webp" type="image/webp">
                <source srcset="assets/{{'Toutes_Images_FR' | translate}}.gif" type="image/gif">
                <img src="assets/{{'Toutes_Images_FR' | translate}}.gif" class="img-avantage" alt="An immersive 3d virtual campus" title="Remote EHS events" loading="lazy">
            </picture>
        </div>
    </div>
</div>
<hr class="mb-0">
<div class="container py-5">
    <div class="text-center mb-5">
        <span class="title sub-bar">{{'Une plus grande prise de conscience des risques par l’action' | translate}}</span>
    </div>
    <div class="row">
        <div class="col-12 col-md-6 mb-4 mb-md-0">
            <div class="block block-rounded abstract-formation h-100">
                <div class="text-center py-2">
                    <span class="text-danger"><i class="far fa-times-circle mr-1"></i>{{'Formations HSE théoriques et abstraites' | translate}}</span>
                </div>
                <div class="img-classroom abstract-formation-img">
                    <picture>
                        <source srcset="assets/Classroom.webp" type="image/webp">
                        <source srcset="assets/Classroom.jpg" type="image/jpg">
                        <img src="assets/Classroom.jpg" class="test" alt="An illustration of a theoretical and abstract EHS training" title="Theoretical and abstract EHS training" loading="lazy">
                    </picture>
                </div>
                <div class="p-4">
                    <p class="text-justify">
                        {{'Lorsqu’ils sont' | translate}}
                        <span class="font-weight-bold text-immersive">{{'théoriques' | translate}}</span>{{', les risques peuvent être' | translate}}
                        <span class="font-weight-bold text-immersive">{{'difficiles à appréhender' | translate}}</span>{{'. Habitués à examiner des chiffres et à entendre des directives ou des évènements relatés de manière très régulière, nos esprits y sont désensibilisés. Les informations transmises à l’oral ou à l’écrit deviennent vite' | translate}}
                        <span class="font-weight-bold text-immersive">{{'abstraites et perdent de leur impact' | translate}}</span>{{'. En revanche, se retrouver soi-même dans une situation dangereuse ou être témoin d’un accident s’avère beaucoup plus marquant.' | translate}}
                    </p>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6">
            <div class="block block-rounded abstract-formation h-100">
                <div class="text-center py-2">
                    <span class="text-success"><i class="far fa-check-circle mr-1"></i>{{'Formations HSE réalistes et intéractives' | translate}}</span>
                </div>
                <div class="img-classroom abstract-formation-img">
                    <picture>
                        <source srcset="assets/Formation_Interactive.webp" type="image/webp">
                        <source srcset="assets/Formation_Interactive.jpg" type="image/jpg">
                        <img src="assets/Formation_Interactive.jpg" class="test" alt="A picture of a man immersed in an EHS VR training" title="Realistic and active EHS training" loading="lazy">
                    </picture>
                </div>
                <div class="p-4">
                    <p class="text-justify">
                        {{'C’est cette notion de présence que le campus virtuel permet d’exploiter. En faisant évoluer les collaborateurs au sein d’un' | translate}}
                        <span class="font-weight-bold text-immersive">{{'monde virtuel semblable en tous points au réel' | translate}}</span>{{', il est possible de leur montrer de manière très imagée les' | translate}}
                        <span class="font-weight-bold text-immersive">{{'conséquences directes et immédiates de leurs actions' | translate}}</span>{{'. Ils peuvent ainsi constater par eux-mêmes l’importance d’appliquer les recommandations à la lettre.' | translate}}
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="citation-block py-5 position-relative">
    <div class="container">
        <div class="text-center mb-5">
            <span class="title sub-bar">{{'Statistiques en temps réel sur les erreurs' | translate}}</span>
            <br>
            <span class="title sub-bar">{{'de procédure commises' | translate}}</span>
        </div>
        <div class="row mb-4">
            <div class="col-12 col-md-6 mb-4 mb-md-0 px-4 d-flex justify-content-center align-items-center">
                <div class="text-justify">
                    {{'Ce qui fait tout l’intérêt de la plateforme' | translate}}
                    <b>IMMERSIVE FACTORY</b>{{', c’est le' | translate}}
                    <span class="font-weight-bold text-immersive">{{'feedback instantané' | translate}}</span>
                    {{'qu’elle permet d’obtenir. C’est notamment pour cette raison qu’elle s’inscrit aussi bien parmi les activités proposées lors d’une' | translate}}
                    <span class="font-weight-bold text-immersive">{{'journée sécurité' | translate}}</span>{{'. Les vidéos de sensibilisation, par exemple, peuvent se révéler d’une grande utilité pour partager des chiffres importants. En revanche, pour donner à un collaborateur la possibilité de mesurer sa propre maîtrise des gestes théoriques, il doit pouvoir les appliquer dans les' | translate}}
                    <span class="font-weight-bold text-immersive">{{'conditions du réel' | translate}}</span>.
                </div>
            </div>
            <div class="col-12 col-md-6 px-4">
                <div class="videoContainer block-rounded abstract-formation">
                    <video poster="https://immersivemisc.s3.eu-west-3.amazonaws.com/videos/posters/Accident.jpg" autoplay="autoplay" muted="muted" webkit-playsinline="true" playsinline="true" loop="loop" preload="auto">
                        <source src="https://immersivemisc.s3.eu-west-3.amazonaws.com/videos/Accidents.webm" type="video/webm">
                        <source src="https://immersivemisc.s3.eu-west-3.amazonaws.com/videos/Accidents.mp4" type="video/mp4">
                    </video>
                </div>
            </div>
        </div>
        <div class="text-center">
            <u>{{'En immersion, les conséquences de ses actions sont immédiates et permettent ainsi au participant :' | translate}}</u>
            <div class="mt-1">
                <i class="fas fa-check-circle mr-1 custom-circle"></i> {{'De procéder à une auto-rectification instantanée très propice à l’adoption d’une attitude adéquate.' | translate}}
            </div>
            <div>
                <i class="fas fa-check-circle mr-1 custom-circle"></i> {{'D’assurer sa propre sécurité ainsi que celle des biens et personnes qui l’entourent sur le long terme.' | translate}}
            </div>
        </div>
    </div>
</div>

<div class="container my-5">
    <div class="text-center mb-4 mt-1">
        <span class="title sub-bar">{{'De nombreux Quiz pour consolider durablement les acquis de vos collaborateurs' | translate}}</span>
    </div>
    <div class="row pt-4">
        <div class="col-12 col-md-6 px-4 mb-md-4 mb-4 text-justify">
            <p>{{'En s’abonnant au campus virtuel, vous aurez accès à' | translate}} <span class="font-weight-bold">{{'une multitude de quiz sur plus de 9 thèmes HSE différents' | translate}}</span>. {{'Fini les heures interminables à concevoir un exercice, simplifiez-vous la tâche et recentrez-vous sur vos enjeux métiers' | translate}}.</p>
            <p><span class="font-weight-bold">{{'Les Quiz' | translate}}</span> {{'sont un moyen très efficace de revenir régulièrement sur des acquis et de les entretenir. Nos Quiz sont créés par des experts de la pédagogie et en étroite collaboration avec des professionnels des différents secteurs d’activité pour pouvoir vous proposer des quiz pertinents à forte valeur ajoutée' | translate}}.</p>
            <p>{{'Aidez-vous des' | translate}} <span class="font-weight-bold">{{'Quiz intégrés au campus' | translate}}</span> {{'pour assurer la continuité de la formation de vos équipes. De cette façon vous gagnez en efficacité !' | translate}}</p>
        </div>
        <div class="col-12 col-md-6 mb-md-0 px-4 mb-md-4 mb-4">
          <div class="block-rounded embed-responsive embed-responsive-16by9 shadow">
            <picture class="embed-responsive-item">
                <source srcset="assets/Training_Room.gif" type="image/webp">
                <source srcset="assets/Training_Room.gif" type="image/gif">
                <img src="assets/Training_Room.jpg" class="img-avantage block-rounded abstract-formation" alt="Campus training room representation" title="Training Room" loading="lazy">
            </picture>
          </div>
        </div>
    </div>
    <div class="row pt-2 text-justify-center">
          <div class="col-12 block-rounded block-quiz blue p-4 info">
            <span class="fa-stack fa-lg mb-3">
              <i class="fas fa-circle fa-stack-2x icon-blue"></i>
              <i class="fas fa-info fa-stack-1x fa-inverse"></i>
            </span>
            <p class="px-5">{{'Possibilité de créer des quiz sur mesure : élaborez vos propres questions, validez les acquis et challengez vos collaborateurs ! N’attendez plus et optez pour les quiz afin de consolider durablement les acquis' | translate}}.</p>
          </div>
    </div>
</div>



<div class="citation-block mt-0">
    <div class="py-5">
        <div class="container text-center">
            <span class="title sub-bar">{{'Les bénéfices des Quiz' | translate}}</span>
            <p class="mt-4 text-justify-center px-3">{{ 'Avec un abonnement mensuel ou annuel, les quiz seront accessibles tous les jours et vos équipes auront la liberté de choisir le bon timing pour s’entraîner. La flexibilité qu’offre cette plateforme inclusive sera appréciée et en quelques semaines, les bons réflexes seront adoptés en situation de risques' | translate}}.</p>
        </div>
        <div class="container mt-5">
            <div class="row all-cards text-justify-center">
                <div class="col-md-6 mb-4">
                    <div class="block-safety block px-4">
                        <div class="d-flex align-items-center">
                            <app-svg-icon class="icon-center icon-rappel" [src]="'assets/svg/POC.svg'" [size]="'45px'"></app-svg-icon>
                        </div>
                        <div class="mt-3">
                            <span class="font-weight-bold black">{{'Augmentez la fréquence des piqûres de rappel' | translate}}</span>
                            <p class="mt-3">{{'Vous investissez probablement déjà pour former vos équipes aux problématiques HSE via des' | translate}} <a class="link" [routerLink]="language.navigateAccordingToLang(['/safety-day'])" title="safety days">{{'journées sécurités' | translate}}</a>, {{'du e-learning. Alors pour capitaliser sur votre investissement, pensez à entretenir les bonnes pratiques de vos équipes, tester et consolider les connaissances régulièrement lors de' | translate}} <span class="font-weight-bold">{{ 'quart d’heure sécurité' | translate}}</span> {{'ou de causerie sécurité' | translate}}.</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 mb-4">
                    <div class="block-safety block px-4">
                        <div class="d-flex align-items-center">
                            <app-svg-icon class="icon-center icon-time" [src]="'assets/svg/clock-regular.svg'" [size]="'45px'"></app-svg-icon>
                        </div>
                        <div class="mt-3">
                            <span class="font-weight-bold black">{{'Optimisez votre temps' | translate}}</span>
                            <p class="mt-3">{{'5 minutes par semaine suffisent pour ancrer durablement vos connaissances ! Encore faut-il trouver ce temps dans nos agendas bien chargés ! Et il n’est pas facile de capter l’attention de tout le monde au même moment lorsque les équipes sont hybrides (sur site et en télétravail). Avec notre campus accessible 24h sur 24h, vos équipes auront la flexibilité de se connecter au quiz quand ils le souhaitent, et d’où ils veulent' | translate}}.</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 mb-4">
                    <div class="block-safety block px-4">
                        <div class="d-flex align-items-center">
                            <app-svg-icon class="icon-center icon-brain" [src]="'assets/svg/circle-brain.svg'" [size]="'45px'"></app-svg-icon>
                        </div>
                        <div class="mt-3">
                            <span class="font-weight-bold black">{{'Ancrez les connaissances durablement' | translate}}</span>
                            <p class="mt-3">{{'Ne perdez pas le bénéfice de votre investissement en formation HSE : entretenez régulièrement les connaissances de vos équipes. Pour résumer en deux statistiques plus parlantes : 50% d’une information est oubliée après une journée si elle n’est pas répétée ou entretenue. 90% de cette même information est perdue au bout d’un an à défaut de rappel' | translate}}.</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 mb-4">
                    <div class="block-safety block px-4">
                        <div class="d-flex align-items-center">
                            <app-svg-icon class="icon-center icon-team" [src]="'assets/svg/user-circle-regular.svg'" [size]="'45px'"></app-svg-icon>
                        </div>
                        <div class="mt-3">
                            <span class="font-weight-bold black">{{'Motivez vos équipes' | translate}}</span>
                            <p class="mt-3">{{'Le quiz c’est la méthode ludique qui a fait ses preuves. En revanche, lorsque vous l’associez au côté immersif, l’attention et l’engagement sont multipliés par 2. Le Jeu et la compétition sont source de motivation et vos alliés pour développer un sentiment de réussite et de fierté !' | translate}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



<div class="container py-5">
    <div class="text-center mb-5">
        <span class="title sub-bar">{{'Outil de gestion innovant pour le débriefing' | translate}}</span>
    </div>
    <div class="row">
        <div class="col-12 col-md-6 mb-4 mb-md-0 px-4">
            <picture>
                <source srcset="assets/Reporting_Moyenne_Horizontal.webp" type="image/webp">
                <source srcset="assets/Reporting_Moyenne_Horizontal.jpg" type="image/jpg">
                <img src="assets/Reporting_Moyenne_Horizontal.jpg" class="img-avantage block-rounded abstract-formation" alt="Website Backoffice: reporting and statistics" title="Reporting and statistics" loading="lazy">
            </picture>
        </div>
        <div class="col-12 col-md-6 px-4 d-flex justify-content-center align-items-center">
            <div>
                {{'Les résultats obtenus « en live » durant l’exercice peuvent bien sûr être' | translate}}
                <span class="font-weight-bold text-immersive">{{'réexaminés a posteriori' | translate}}</span>{{'. À l’occasion d’une' | translate}}
                <span class="font-weight-bold text-immersive">{{'journée sécurité' | translate}}</span>{{', de telles fonctionnalités peuvent même servir à expliciter certains points importants auprès d’autres membres de l’équipe. Si l’expérience « sur le vif » permet d’appréhender la sécurité de manière extrêmement pertinente, les' | translate}}
                <span class="font-weight-bold text-immersive">{{'statistiques' | translate}}</span>
                {{'qui en découlent apportent un élément de recul. Il devient alors possible d’aller plus loin dans' | translate}}
                <span class="font-weight-bold text-immersive">{{'l’interprétation des évènements' | translate}}</span>
                {{'et de comprendre pourquoi certaines erreurs peuvent être commises et' | translate}}
                <span class="font-weight-bold text-immersive">{{'comment les éviter' | translate}}</span>.
            </div>
        </div>
    </div>

</div>
<hr class="my-0">
<div class="container py-5">
    <div class="text-center mb-5">
        <span class="title sub-bar">{{'Informations pratiques sur' | translate}}</span>
        <br>
        <span class="title sub-bar">{{'les « Journées et Semaines sécurité »' | translate}}</span>
    </div>
    <div class="text-center">
        {{'Organiser une journée sécurité autour d\'ateliers virtuels place cette journée au cœur de votre culture entreprise tout en proposant aux salariés une expérience aussi enrichissante que ludique. Sur le plan pratique, la réalité virtuelle présente également des avantages indéniables, car elle est compatible avec toutes sortes de besoins.' | translate}}
    </div>
</div>
<div class="block-free-access py-5">
    <div class="container px-5">
        <div class="block p-0">
            <ul class="nav landing-tabs" id="myTab" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" id="lieu-tab" data-toggle="tab" href="#lieu" role="tab" aria-controls="lieu" aria-selected="true" title="location">
                        <div class="icon"><i class="fas fa-home"></i></div>
                        <b class="text-uppercase">{{'Lieu' | translate}}</b>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="duree-tab" data-toggle="tab" href="#duree" role="tab" aria-controls="duree" aria-selected="false" title="duration">
                        <div class="icon"><i class="fas fa-clock"></i></div>
                        <b class="text-uppercase">{{'Durée' | translate}}</b>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="participants-tab" data-toggle="tab" href="#participants" role="tab" aria-controls="participants" aria-selected="false" title="participants">
                        <div class="icon"><i class="fas fa-users"></i></div>
                        <b class="text-uppercase">{{'Participants' | translate}}</b>
                    </a>
                </li>
            </ul>
            <hr class="my-0">
            <div class="tab-content text-center py-4 px-3 px-md-5" id="myTabContent">
                <div class="tab-pane fade show active text-justify" id="lieu" role="tabpanel" aria-labelledby="lieu-tab">
                    <b class="sub-bar">{{'LIEU : Chez vous, au bureau ou ailleurs' | translate}}</b>
                    <p class="mb-0 mt-4">{{'Le campus HSE virtuel, c’est vivre une situation comme si vous y étiez, mais aucune contrainte géographique ou d’infrastructure. Tout le monde ne peut pas accueillir un exercice grandeur nature dans ses propres locaux. En revanche, un équipement VR adapté ou un PC suffit à créer l’illusion du terrain sans mobiliser beaucoup d’espace, voire entièrement à distance. Nous vous proposons par exemple une plateforme dédiée à ce type d’évènement à travers laquelle vos collaborateurs pourront interagir dans des conditions ultra-réalistes sans le moindre contact physique. Même dans la situation que nous connaissons actuellement, vous pouvez planifier une journée sécurité d’une grande efficacité sans aucune obligation de lieu et prévoir des activités pour un nombre de participants très important.' | translate}}</p>
                </div>
                <div class="tab-pane fade text-justify" id="duree" role="tabpanel" aria-labelledby="duree-tab">
                    <b class="sub-bar">{{'Durée : ponctuelle ou illimitée' | translate}}</b>
                    <p class="mb-1 mt-4">{{'Selon vos propres contraintes organisationnelles, le concept est complètement revisité : grâce au e-safety campus, plus de contraintes de temps. Vos collaborateurs se connectent quand ils le souhaitent ou via une invitation envoyée par email. Cette manière de procéder peut s’avérer intéressante si vous ne souhaitez pas impacter la productivité de l’ensemble de vos équipes pendant toute une journée.' | translate}}</p>
                    <p class="mb-0">{{'La diversité des exercices et des thématiques vous permet d’organiser des formations ou des évènements spécifiques selon vos besoins, en individuel ou en collectif.' | translate}}</p>
                </div>
                <div class="tab-pane fade text-justify" id="participants" role="tabpanel" aria-labelledby="participants-tab">
                    <b class="sub-bar">{{'Nombre de participants : illimité' | translate}}</b>
                    <p class="mb-1 mt-4">{{'Organiser une journée sécurité sous forme de campus virtuel pour l’ensemble de l’entreprise permet de mobiliser l’attention de chacun sur cette question fondamentale et d’aborder la prévention autrement. Vous pourrez par exemple créer des équipes et faire évoluer un grand nombre de collaborateurs dans le même espace virtuel tout en répliquant de façon encore plus convaincante des situations dangereuses.' | translate}}</p>
                    <p class="mb-0">{{'Si vous optez pour des exercices individuels, nous vous aiderons à en optimiser la quantité afin de tirer le meilleur parti de notre plateforme dédiée. Nous travaillons aussi sur la nature des scénarios pour assurer une diversité idéale.' | translate}}</p>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container py-5 text-center">
    {{'Nos exercices sont élaborés avec l’aide de professionnels HSE et de grands groupes industriels, et sont conçus pour exposer vos employés à des accidents virtuels afin d’influencer durablement leur comportement dans la vie réelle et de leur faire prendre conscience de l’importance de suivre des procédures dans le but de réduire les accidents dus aux facteurs humains.' | translate}}
</div>
<hr class="my-0">
<div class="container py-5">
    <div class="text-center mb-5">
        <span class="title sub-bar">{{'Objectifs de la formation HSE/QHSE immersive en VR ou en 3D' | translate}}</span>
    </div>
    <div class="row">
        <div class="col-12 col-md-6 mb-4 mb-md-0 px-4 d-flex justify-content-center align-items-center">
            <picture>
                <source srcset="assets/preview.webp" type="image/webp">
                <source srcset="assets/preview.jpg" type="image/jpg">
                <img src="assets/preview.jpg" alt="Visual of the VR EHS Awareness workshop developped by Immersive Factory" title="EHS Awareness" class="block-rounded abstract-formation" loading="lazy">
            </picture>
        </div>
        <div class="col-12 col-md-6 px-4 d-flex justify-content-center align-items-center">
            <div>
                <div class="d-flex mb-3">
                    <i class="fas fa-check-circle mr-1 custom-circle" style="padding-top: 3px;"></i>
                    <p class="mb-0 text-justify">
                        {{'Créez une simulation virtuelle d’accidents pour' | translate}}
                        <span class="font-weight-bold text-immersive">{{'exposer vos équipes aux dangers' | translate}}</span>
                        {{'de leur métier et minimiser les risques dans la vie réelle.' | translate}}
                    </p>
                </div>
                <div class="d-flex mb-3">
                    <i class="fas fa-check-circle mr-1 custom-circle" style="padding-top: 3px;"></i>
                    <p class="mb-0 text-justify">
                        <span class="font-weight-bold text-immersive">{{'Générez des statistiques' | translate}}</span>
                        {{'précises sur les erreurs de procédure commises pendant l’expérience immersive et comparez les résultats entre vos différents sites afin de débriefer vos équipes et de conduire le changement.' | translate}}
                    </p>
                </div>
                <div class="d-flex">
                    <i class="fas fa-check-circle mr-1 custom-circle" style="padding-top: 3px;"></i>
                    <p class="mb-0 text-justify">
                        {{'Impliquez vos équipes dans des simulations immersives uniques et' | translate}}
                        <span class="font-weight-bold text-immersive">{{'anticipez ainsi leur comportement' | translate}}</span>{{'pour leur permettre d’adopter la bonne attitude en toutes circonstances.' | translate}}
                    </p>
                </div>
            </div>
        </div>
    </div>
    <hr class="my-5">
    <div class="row">
        <div class="col-12 col-md-6 mb-4 mb-md-0 d-flex justify-content-center align-items-center">
            <div class="text-justify">
                <p class="font-weight-bold mb-3" style="font-size: 20px;">{{'Organiser ses journées sécurité' | translate}}</p>
                <p class="mb-0">
                    {{'Notre mission est d’accompagner les entreprises dans la construction d’un environnement de travail propice au' | translate}}
                    <span class="font-weight-bold text-immersive">{{'bien-être et à la sécurité de chacun' | translate}}</span>{{'. Notre approche pédagogique se caractérise par une' | translate}}
                    <span class="font-weight-bold text-immersive">{{'sensibilisation fédératrice, dynamique et pérenne' | translate}}</span>{{'. Nous avons à cœur de donner à la' | translate}}
                    <span class="font-weight-bold text-immersive">{{'maîtrise des accidents et des risques professionnels' | translate}}</span>
                    {{'une place prépondérante parmi les préoccupations des sociétés et de leur offrir les moyens de prendre celle-ci en main.' | translate}}
                </p>
            </div>
        </div>
        <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
            <img src="assets/OnSite.svg" width="100%" alt="Organize your Safety Days" title="On site workers" loading="lazy">
        </div>
    </div>
    <hr class="my-5">
    <div class="row">
        <div class="col-12 col-md-6 mb-4 mb-md-0 d-flex justify-content-center align-items-center">
            <img src="assets/{{'Remote_FR.svg' | translate}}" width="100%" alt="A turnkey virtual campus" title="VR workshops" loading="lazy">
        </div>
        <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
            <div class="text-justify">
                <p class="font-weight-bold mb-3" style="font-size: 20px;">{{'Une plateforme virtuelle clé en main' | translate}}</p>
                <p class="mb-0">
                    {{'Nous souhaitons faire de l’' | translate}}<span class="font-weight-bold text-immersive">{{'environnement' | translate}}</span>{{', de la' | translate}}
                    <span class="font-weight-bold text-immersive">{{'santé' | translate}}</span>
                    {{'et de la' | translate}}
                    <span class="font-weight-bold text-immersive">{{'sécurité' | translate}}</span>
                    {{'l’affaire de tous au quotidien. Nos' | translate}}
                    <span class="font-weight-bold text-immersive">{{'plateformes multi-user' | translate}}</span>
                    {{'et les contenus de nos' | translate}}
                    <span class="font-weight-bold text-immersive">{{'formations HSE digitales' | translate}}</span>
                    {{'s’adaptent à vos besoins et à ceux de vos équipes.' | translate}}
                    <span class="font-weight-bold text-immersive">{{'Sensibilisation, initiation et formation' | translate}}</span>
                    {{'prennent appui sur le virtuel pour ancrer les apprentissages dans la réalité et offrir à vos collaborateurs une expérience de grande valeur, soucieuse de respecter leurs impératifs. C’est pourquoi nous proposons des exercices conçus pour marquer les esprits pour de bon.' | translate}}
                    <span class="font-weight-bold text-immersive">{{'Des notions acquises plus rapidement' | translate}}</span>{{', c’est davantage de temps dédié à l’approfondissement pour continuer à aller de l’avant.' | translate}}
                </p>
            </div>
        </div>
    </div>
</div>

<hr class="my-0">
<div class="container py-5">
    <div class="text-center mb-5">
        <span class="title sub-bar">{{'Exemple de l’organisation d’un évènement sécurité autour des' | translate}}</span>
        <br>
        <span class="title sub-bar">{{'risques au sein des entrepôts au sein du campus virtuel' | translate}}</span>
    </div>
    <div class="row mb-5">
        <div class="col-6 col-md-3 mb-4 mb-md-0 text-center">
            <div class="colab-icon"><i class="fas fa-building"></i></div>
            <div class="colab-nb">5</div>
            <div class="colab-desc">{{'sites' | translate}}</div>
        </div>
        <div class="col-6 col-md-3 mb-4 mb-md-0 text-center">
            <div class="colab-icon"><i class="fas fa-globe-europe"></i></div>
            <div class="colab-nb">5</div>
            <div class="colab-desc">{{'pays' | translate}}</div>
        </div>
        <div class="col-6 col-md-3 text-center">
            <div class="colab-icon"><i class="fas fa-language"></i></div>
            <div class="colab-nb">5</div>
            <div class="colab-desc">{{'langues' | translate}}</div>
        </div>
        <div class="col-6 col-md-3 text-center">
            <div class="colab-icon"><i class="fas fa-users"></i></div>
            <div class="colab-nb">500</div>
            <div class="colab-desc">{{'collaborateurs' | translate}}</div>
        </div>
    </div>

    <img src="assets/Usine_Collegues.svg" width="100%" alt="Co-workers using VR headset in a warehouse" title="Safety Day" class="mb-5" loading="lazy">
    <h4 class="font-weight-bold text-center text-uppercase">{{'Le responsable de cet évènement, via son back office va pouvoir :' | translate}}</h4>
    <div class="row">
        <div class="col-12 col-md-6 mb-4 mb-md-0 p-4">
            <picture>
                <source srcset="assets/Ateliers.webp" type="image/webp">
                <source srcset="assets/Ateliers.jpg" type="image/jpg">
                <img src="assets/Ateliers.jpg" class="img-avantage block-rounded abstract-formation" width="100%" alt="Website backoffice: select your workshops" title="Back-office" loading="lazy">
            </picture>
            <p class="mb-0 text-justify mt-3">
                <span class="font-weight-bold text-immersive">{{'Sélectionner les exercices concernés par la thématiques' | translate}}</span>
                {{'(Hazard Spotting in a warehouse, Driving Behaviour - Forklift, On-site circulation - Forklift truck - Pedestrian view, Sensitization - Hygiene Office, Eco-Friendly Actions, Quizz). Ils seront accessibles à tous les collaborateurs.' | translate}}
            </p>
        </div>
        <div class="col-12 col-md-6 mb-4 mb-md-0 p-4">
            <picture>
                <source srcset="assets/Cinema.webp" type="image/webp">
                <source srcset="assets/Cinema.jpg" type="image/jpg">
                <img src="assets/Cinema.jpg" class="img-avantage block-rounded abstract-formation" width="100%" alt="Website backoffice: select your videos" title="Back-office" loading="lazy">
            </picture>
            <p class="mb-0 text-justify mt-3">
                <span class="font-weight-bold text-immersive">{{'Uploader des vidéos dans la salle de cinéma virtuelle' | translate}}</span>
                {{'qui pourront être visualisées par tous les collaborateurs (vidéo sur la culture sécurité sur Président de la société, vidéo de situation sur les accidents avec chariots élévateur).' | translate}}
            </p>
        </div>
        <div class="col-12 col-md-6 mb-4 mb-md-0 p-4">
            <picture>
                <source srcset="assets/Conference.webp" type="image/webp">
                <source srcset="assets/Conference.jpg" type="image/jpg">
                <img src="assets/Conference.jpg" class="img-avantage block-rounded abstract-formation" width="100%" alt="Immersive Factory virtual campus conference room" title="Conference room" loading="lazy">
            </picture>
            <p class="mb-0 text-justify mt-3">
                <span class="font-weight-bold text-immersive">{{'Préparer des présentations' | translate}}</span>
                {{'avec notamment les évolutions comparées de l’accidentologie des taux de fréquence sur chaque site, qu’il utilisera au cours au cours de séances plénières par pays dans la salle de séminaire ou bien qu’il demandera à ses préventeurs de relayer en petits groupes dans les salles de formation virtuelle.' | translate}}
            </p>
        </div>
        <div class="col-12 col-md-6 mb-4 mb-md-0 p-4">
            <picture>
                <source srcset="assets/Reporting_Moyenne_Horizontal.webp" type="image/webp">
                <source srcset="assets/Reporting_Moyenne_Horizontal.jpg" type="image/jpg">
                <img src="assets/Reporting_Moyenne_Horizontal.jpg" class="img-avantage block-rounded abstract-formation" width="100%" alt="Website Backoffice: reporting and statistics" title="Reporting and statistics" loading="lazy">
            </picture>
            <p class="mb-0 text-justify mt-3">
                <span class="font-weight-bold text-immersive">{{'Régulièrement visualiser les résultats comparés de chaque site' | translate}}</span>
                {{'pour identifier les bons et les mauvais élèves afin le cas échéant de mettre en place des actions spécifiques.' | translate}}
            </p>
        </div>
    </div>
</div>
<!-- <div class="text-center pb-5">
    <div class="bottom-icon mb-3"><i class="fas fa-paper-plane"></i></div>
    <p class="mb-0">
        <span class="font-weight-bold text-immersive">{{'Transmettre les résultats individuels aux responsables' | translate}}</span>
        <br>
        {{'des sites et à la DRH du groupe.' | translate}}
    </p>
</div> -->

<hr>
<div class="container mb-5">
    <div class="text-center my-5 mb-5">
        <span class="title sub-bar">{{"Vous voulez assurer la sécurité de vos employés et réduire le nombre d’accidents sur votre lieu de travail ?" | translate}}</span>
    </div>
    <p class="text-justify">{{"Nos simulations de formation e-learning sont le moyen idéal d’y parvenir. Elles exposent les membres de votre équipe aux risques auxquels ils sont confrontés au travail, afin qu’ils puissent apprendre à éviter les situations dangereuses" | translate}}.</p>
    <p class="text-justify">{{"Suivez les cours d’e-learning HSE à votre rythme, que vous soyez à la maison ou au travail ! À la fin du cours HSE e-learning, vous recevrez un certificat vous permettant de faire valoir votre formation !" | translate}}</p>
    <p class="text-justify">{{"Nos simulations sont réalistes et précises. Vous pouvez générer des statistiques sur les erreurs de procédure commises au cours de l’expérience, pour stimuler le changement au sein de votre organisation. De plus, nos simulations sont engageantes et uniques, pour que vos équipes soient enthousiastes à l’idée d’y participer" | translate}}.</p>
    <p class="text-justify">{{"Pour rappel, l’employeur est tenu de désigner un ou plusieurs salariés compétents pour gérer les questions de santé et de sécurité au travail, les activités de protection et de prévention des risques professionnels au titre du code du travail (art. L. 4644-1 et R. 4644-1) à compter du 1er juillet 2012" | translate}}.</p>
</div>
